module.exports = __webpack_public_path__ + "static/media/picture-of-the-sky-and-its-gradients-from-the-hazy-QCMG7FD.349e77f3.jpg";